module.exports = __webpack_public_path__ + "static/img/xueshu.fa85777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tout/xueshu.jpg
// module id = Rr5t
// module chunks = 1